import React, { useEffect, useState } from "react";
import { HelmetProvider } from "react-helmet-async";
import { Helmet } from "react-helmet";
import AdminLayout from "../components/AdminLayout";
import { News } from "../../models/News";
import NewsList from "../news/NewsList";
import { BASE_URLS } from "../../config/urls";
import { apiFetch } from "../../utils/api";
import { NewsCreateModal } from "../news/NewsCreateModal";
import "../news/news.css"
const NewsAdminPage: React.FC = () => {
    const [news, setNews] = useState<News[]>([]);

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [editingNews, setEditingNews] = useState<News | undefined>(undefined);

    useEffect(() => {
        apiFetch(`${BASE_URLS.api}/news`)
            .then((res) => res.json())
            .then((data) => setNews(Array.isArray(data) ? data : []))
            .catch((err) => console.error("Ошибка загрузки новостей:", err));
    }, []);

    const openCreate = () => {
        setEditingNews(undefined);
        setIsModalOpen(true);
        document.body.style.overflow = "hidden";
    };

    const openEdit = (id: number) => {
        const item = news.find((n) => n.id === id);
        if (!item) return;
        setEditingNews(item);
        setIsModalOpen(true);
        document.body.style.overflow = "hidden";
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setEditingNews(undefined);
        document.body.style.overflow = "scroll";
    };

    return (
        <AdminLayout isPopupVisible={isModalOpen}>
            <HelmetProvider>
                <Helmet title="Админка новостей" />
            </HelmetProvider>

            <div className="page_content service-users-page">
                <div style={{ width: "100%" }}>
                    <section className="admin-card" style={{ margin: "90px 15% 10px 8%" }}>
                        <h1 className="admin-heading">Управление новостями</h1>
                        <p className="admin-subtitle">Создание, изменение и удаление новостей.</p>

                        <div className="service-users-header">
                            <button type="button" className="admin-button-primary" onClick={openCreate}>
                                + Создать новость
                            </button>
                        </div>
                    </section>
                </div>

                <NewsList news={news} isAdmin itemsPerPage={10} onEyeClick={(id) => openEdit(id)} />

                <NewsCreateModal isOpen={isModalOpen} onClose={closeModal} newsItem={editingNews} />
            </div>
        </AdminLayout>
    );
};

export default NewsAdminPage;
